import { APP_CONFIG } from "app.config";

export class NotificationConstant {
    static GET_PAGING_LIST_NOTIFICATIONS: string = APP_CONFIG.XPSNS + 'notification/pivotPaging';
    static GET_PAGING_LIST: string = APP_CONFIG.XPSNS + 'notification/pivotPagingSummary';
    static PIVOT_COUNT: string = APP_CONFIG.XPSNS + 'notification/pivotCount';
    static GET_COUNT_UNREAD: string = APP_CONFIG.XPSNS + 'notification/countUnread';
    static MARK_READ: string = APP_CONFIG.XPSNS + 'notification/updateRead';
    static READ_ALL = APP_CONFIG.XPSNS + 'notification/readAll';
    static GET_DETAIL_NOTIFICATION: string = APP_CONFIG.XPSNS + 'notification/getByAggId?aggId=';

    static UNREAD: boolean = true;
    static READ: boolean = false;
    static LIMIT: number = 10;
}
